import { Action } from '~/components/Claim/Actions/types';

export const processDamageAssessmentMarkdown = (action: Action): string => {
  const explanation = action?.metadata?.explanation as string;
  const additional_actions = action?.metadata?.additional_actions as string;
  return `${explanation}\n\n${additional_actions}`;
};
